import { PrimaryButton } from "components/ButtonMenu/Button";
import "@reach/dialog/styles.css";
import { getTranslation } from "dictionary";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useMenuContext } from "context/MenuContext";
import { AdditionalField } from "@prisma/client";
import FieldRenderer from "components/AdditionalFields/FieldRenderer";

const validateSchema = (lang: "EN" | "ES", fields: AdditionalField[]) => {
  const requiredMessage = lang === "ES" ? "Campo requerido" : "Required";
  const shape = fields.reduce((acc: any, field) => {
    switch (field.type) {
      case "MESSAGE":
        break;
      case "BOOLEAN":
        // if (field.required) {
        //   acc[field.id] = Yup.boolean().required(requiredMessage);
        // } else {
        // }
        acc[field.id] = Yup.boolean();
        break;
      case "TEXT":
      case "SHORT_TEXT":
      case "DATE":
      case "DROPDOWN":
      case "NUMBER":
        if (field.required) {
          acc[field.id] = Yup.string().required(requiredMessage);
        } else acc[field.id] = Yup.string();
        break;
    }
    return acc;
  }, {});
  return Yup.object().shape(shape);
};
interface Props {
  language: "ES" | "EN";
  savingOrder: boolean;
  onSubmit: (values: { [key: string]: any }[]) => void;
}

const OrderModalStep2: React.FC<Props> = ({
  savingOrder,
  language,
  onSubmit,
}) => {
  const { additionalFields } = useMenuContext().cart;
  return (
    <Formik
      // @ts-ignore
      initialValues={{}}
      validationSchema={validateSchema(language, additionalFields)}
      onSubmit={onSubmit}
    >
      {({ values, errors, submitCount }) => {
        return (
          <Form className="px-6">
            {additionalFields.map((field) => (
              <FieldRenderer key={field.id} field={field} />
            ))}
            <div className=" py-6">
              <PrimaryButton
                ariaLabel="Checkout"
                type="submit"
                loading={savingOrder}
                disabled={submitCount && Object.keys(errors).length > 0}
              >
                {getTranslation("menu_order", "CHECKOUT", language)}
              </PrimaryButton>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default OrderModalStep2;
